export const formatDate = (dateString) => {
  if (!dateString) return "--";
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  let date = new Date(dateString).toLocaleDateString(undefined, options);
  if (date === "Invalid Date") {
    return "--";
  }
  return date;
};

/** Resolve a display name from common staff payload shapes. */
export const staffName = (member) =>
  member?.name ||
  [member?.first_name, member?.last_name].filter(Boolean).join(" ") ||
  member?.email ||
  "--";

/** Resolve the active flag from either `status` or `isActive`. */
export const staffIsActive = (member) => {
  const status = String(member?.status || "").toUpperCase();
  if (member?.status) {
    return status === "ACTIVE";
  }
  return Boolean(member?.isActive);
};

/** Resolve the avatar image URL for a staff member. */
export const staffAvatar = (member) =>
  member?.avatar || member?.image || member?.profileImage || null;

/** Badge styling for a status value. */
export const statusBadgeClass = (status) => {
  switch (String(status || "").toUpperCase()) {
    case "ACTIVE":
      return "badge bg-success";
    case "SUSPENDED":
    case "DISABLED":
    case "DEACTIVATED":
      return "badge bg-danger";
    case "INVITED":
    case "PENDING":
      return "badge bg-warning text-dark";
    default:
      return "badge bg-secondary";
  }
};